import { createIcon } from '@consta/icons/Icon'
import type { FC, SVGProps } from 'react'

const IconExpandHalfUpM: FC<SVGProps<SVGSVGElement>> = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 5" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M 4 0 L 7.9749 3.9749 L 7.2678 4.682 L 4 1.4142 L 0.7323 4.682 L 0.0252 3.9749 L 4 0 Z"
    />
  </svg>
)

export const IconExpandHalfUp = createIcon({
  name: 'IconExpandHalfUp',
  l: IconExpandHalfUpM,
  m: IconExpandHalfUpM,
  s: IconExpandHalfUpM,
  xs: IconExpandHalfUpM,
})
